import React, {Component} from "react";
import cookie from "react-cookies";
import {getAllAccessPolicies, getDefaultPolicies} from "../utils/api";
import {Button, Col, Input, message, Row, Table} from "antd";
import {Button as MuiButton, ThemeProvider, Tooltip} from "@mui/material";
import {aclPermissions, hasPermissions} from "../const/ACLPermissions";
import {DeleteOutlined, EditOutlined, PlusOutlined, SearchOutlined} from "@ant-design/icons";
import {openEndPoint} from "../utils/utils";
import DeletePolicy from "./deletePolicy";
import TrailLinks from "../component/utils/trail_links";
import {Loader} from "../utils/const";
import {defaultTheme} from "../component/gammaviewer/themes";

const {Search} = Input;

class ManagePolicyTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedRowKeys: [],
            isFetching: false,
            showDeletePolicyModal: false,
            isOkClicked: false,
            selectedPolicy: '',
            allPolicies: [],
            defaultPolicies: [],
            currentPage: 1,
            totalPages: -1,
            totalItems: -1,
            search: '',
            filteredPolicies: [],
        }
    }

    componentDidMount() {
        this.fetchDefaultPolicies();
        this.fetchAllPolicies();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.showDeletePolicyModal === true && this.state.showDeletePolicyModal === false && this.state.isOkClicked) {
            this.fetchAllPolicies()
        }
    }

    fetchDefaultPolicies = () => {
        getDefaultPolicies().then(res => this.setState({defaultPolicies: res['defaults']}))
    }

    fetchAllPolicies = () => {
        const organisation = cookie.load('organisation') || cookie.load('organisation_id')
        this.setState({isFetching: true});
        getAllAccessPolicies(organisation, this.state.currentPage, '').then(data => {
            this.setState({
                isFetching: false,
                allPolicies: data['all_access_policies'],
                filteredPolicies: data['all_access_policies'],
                totalPages: data['total_pages'],
                totalItems: data['count']
            })
        })
    }

    handleCreatePolicy = () => {
        openEndPoint("/createpolicy/", false, true);
    }

    handleEditPolicy = (id) => {
        openEndPoint("/editpolicy/" + id, false, true);
    }

    openDeletePolicyModal = (policy) => this.setState({
        showDeletePolicyModal: true,
        selectedPolicy: policy || ''
    })

    closeDeletePolicyModal = (isOkClicked) => this.setState({
        showDeletePolicyModal: false,
        selectedPolicy: '',
        isOkClicked: isOkClicked
    })

    onInputChange = (e) => {
        this.setState({ search: e.target.value });
    };

    onPolicySearch = async () => {
        const { search } = this.state;

        try {
            const organisation = cookie.load('organisation') || cookie.load('organisation_id')
            this.setState({isFetching: true});
            getAllAccessPolicies(organisation, 1, search).then((data) => {
                this.setState({
                    filteredPolicies: data['all_access_policies'], currentPage: 1, isFetching: false,
                    totalPages: data['total_pages'], totalItems: data['count']
                })
            })

        } catch (error) {
            message.error('Error fetching search results');
        }
    };


    render() {
        const {isFetching, currentPage, totalItems, filteredPolicies, search} = this.state;
        const editPolicy = !hasPermissions([aclPermissions.edit_policy]);
        const deletePolicy = !hasPermissions([aclPermissions.delete_policy]);
        const createPolicy = !hasPermissions([aclPermissions.create_policy]);

        const rowSelection = {
            onChange: (selectedRowKeys, selectedRows) => {
                this.setState({
                    selectedRowKeys: selectedRowKeys
                })
            },
            selectedRowKeys: this.state.selectedRowKeys,
            columnWidth: '10px',
        };
        const columns = [
            // {
            //     title: 'Index',
            //     dataIndex: 'index',
            //     key: 'index',
            //     render: (text, record, index) => index + 1,
            //
            // },
            {
                title: 'Policy Name',
                dataIndex: 'name',
                key: 'name',
                render: (text, record) => {
                    let defaultPolicy = false;
                    if ((this.state.defaultPolicies).includes(record.name)) {
                        defaultPolicy = true;
                    }
                    return <span style={{fontWeight: defaultPolicy ? 'bold' : null}}>{record.name}</span>
                }
            },
            {
                title: 'Actions',
                dataIndex: 'action',
                key: 'action',
                render: (text, record) => {
                    let disableDeletion = false;
                    if ((this.state.defaultPolicies).includes(record.name)) {
                        disableDeletion = true;
                    }
                    return <Row type="flex" gutter={4}>
                        <Col>
                            <Tooltip
                                title={editPolicy ? "Cannot edit policy. Contact administration to get access" : ''}>
                                <span>
                                    <MuiButton
                                        variant="outlined"
                                        color="primary"
                                        size="medium"
                                        disabled={editPolicy}
                                        sx={{fontSize: 10, width: "12px"}}
                                        onClick={() => this.handleEditPolicy(record.id)}>
                                        <EditOutlined style={{height: "12px"}}/>
                                    </MuiButton>
                                </span>
                            </Tooltip>
                        </Col>
                        <Col>
                            <Tooltip
                                title={deletePolicy ? "Cannot delete policy. Contact administration to get access" : disableDeletion ? "Can't delete Default policy" : ''}>
                                <span>
                                    <MuiButton
                                        variant="outlined"
                                        color="primary"
                                        size="medium"
                                        disabled={deletePolicy || disableDeletion}
                                        onClick={() => this.openDeletePolicyModal(record.name)}>
                                        <DeleteOutlined style={{height: "12px"}}/>
                                    </MuiButton>
                                </span>
                            </Tooltip>
                        </Col>
                    </Row>
                }
            },
        ];

        return (
            <ThemeProvider theme={defaultTheme}>
                <div className={'full-parent all-slides'}>
                    <Row span={4} type="flex" justify="space-between" style={{flexDirection: "row-reverse"}}
                         id={"aa13"}>
                        <Col span={5}>
                            <Tooltip
                                title={createPolicy ? "Cannot create policy. Contact administration to get access" : ''}>
                            <span>
                                <MuiButton
                                    onClick={this.handleCreatePolicy}
                                    variant="outlined"
                                    disabled={createPolicy}
                                    color="primary"
                                    size="small"
                                    endIcon={<PlusOutlined/>}
                                    style={{marginBottom: 16}}
                                >
                            Create New Policy
                        </MuiButton>
                            </span>
                            </Tooltip>
                        </Col>
                        <Col span={7}>
                            <Search
                                value={search || ''}
                                onChange={this.onInputChange}
                                placeholder="Search by Policy name"
                                onSearch={this.onPolicySearch}
                                enterButton={<Button color="primary" variant="outlined">
                                    <SearchOutlined/></Button>}
                            />
                        </Col>
                        <Col span={4}>
                            <TrailLinks trails={[
                                {label: 'Home', link: '/'},
                                {label: 'Manage Users', link: '/accesscontrol/'},
                                {label: 'Manage Policies', link: ''}
                            ]}/>
                        </Col>
                    </Row>
                    <Row>
                        <div className="heading-style main-heading-style" id={"topEl"}>
                            <b>Manage Policies And Permissions</b>
                        </div>
                        {isFetching ? <Loader loadingText="Loading"/> : <Table
                            style={{marginTop: 20}}
                            dataSource={filteredPolicies}
                            columns={columns}
                            rowSelection={rowSelection}
                            pagination={{
                                current: currentPage,
                                total: totalItems,
                                pageSize: 10,
                                showTotal: (total, range) =>
                                    `Showing ${range[0]}-${range[1]} out of ${total} total Policies`,
                                onChange: (page) => {
                                    this.setState({currentPage: page}, this.fetchAllPolicies);
                                },
                            }}
                        />}
                    </Row>
                    {this.state.showDeletePolicyModal &&
                        <DeletePolicy
                            policy={this.state.selectedPolicy}
                            showModal={this.state.showDeletePolicyModal}
                            closeModal={(isOkClicked) => this.closeDeletePolicyModal(isOkClicked)}
                        />
                    }
                </div>
            </ThemeProvider>
        )
    }
}

export default ManagePolicyTable;